
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';

export const userEnvironmentsConfig = {
    mainEnvironment: {
        title: 'general',
        icon: <ApartmentOutlinedIcon />,
    },
};
